import {
  OnboardingItem,
  OnboardingTarget,
} from '@epicuro-next/constants/rule-engine/onboarding-rules';
import { createAction, props } from '@ngrx/store';

export const setOnboardingConfiguration = createAction(
  '[Onboarding] Set the onboarding configuration',
  props<{
    [OnboardingTarget.SalesRep]: OnboardingItem[];
    [OnboardingTarget.Consumer]: OnboardingItem[];
  }>(),
);

export const setActiveOnboarding = createAction(
  '[Onboarding] Set the active onboarding value',
  props<{
    target: OnboardingTarget | null;
  }>(),
);

export const setOnboardingViewed = createAction(
  '[Onboarding] Set the viewed status of the onboarding for the user',
);
